import { Button, Card, Col, Form, Grid, Row } from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { CustomMessage, CustomPassword } from "../../../../components";
import {
  InputRequired,
  PasswordFormat,
} from "../../../../validations/validations";
import { useChangePassword } from "./changepass.hooks";
import styles from "./style.module.scss";

const ChangePassword: React.FC = () => {
  const [form] = Form.useForm();
  const { t } = useTranslation();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();

  const [uploading, setUploading] = useState<boolean>(false);

  const { mutate: changePassword } = useChangePassword();

  const onUpdatePassword = async (value: any) => {
    console.debug("value", value);
    setUploading(true);
    await changePassword(
      {
        params: value,
      },
      {
        onSuccess: (success: any) => {
          CustomMessage({ alertMessage: t("message.success.changepass") });
          form.resetFields();
          setUploading(false);
        },
        onError: (err: any) => {
          console.debug("err", err);
          CustomMessage({
            alertMessage: t([
              `error.${err.data.result.code}`,
              err.data.result.message,
            ]),
            alertType: "error",
          });
          setUploading(false);
        },
      }
    );
  };

  return (
    <Card
      className={styles.orderCard}
      style={{ marginTop: 4 }}
      variant="borderless"
      title={t("profile.changepassword")}
      size={screens.xs ? "small" : "default"}
    >
      <Form
        requiredMark={true}
        form={form}
        layout={"vertical"}
        onFinish={onUpdatePassword}
      >
        <Row gutter={[13, 16]}>
          <Col span={screens.md ? 8 : 24}>
            <Form.Item
              name="password"
              label={t("profile.oldpass")}
              rules={[
                InputRequired(t, "profile.oldpass"),
                PasswordFormat(t, 6, 20),
              ]}
            >
              <CustomPassword placeholder={t("profile.oldpass.hint")} />
            </Form.Item>
          </Col>
          <Col span={screens.md ? 8 : 24}>
            <Form.Item
              name="new_password"
              label={t("profile.newpass")}
              rules={[
                InputRequired(t, "profile.oldpass"),
                PasswordFormat(t, 6, 20),
              ]}
            >
              <CustomPassword placeholder={t("profile.newpass.hint")} />
            </Form.Item>
          </Col>
          <Col span={screens.md ? 8 : 24}>
            <Form.Item
              dependencies={["new_password"]}
              name="confirm_new_password"
              label={t("profile.newpass.repeat")}
              rules={[
                InputRequired(t, "profile.newpass.repeat"),
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue("new_password") === value) {
                      return Promise.resolve();
                    }

                    return Promise.reject(new Error(t("error.repeat.pass")));
                  },
                }),
              ]}
            >
              <CustomPassword placeholder={t("profile.newpass.repeat.hint")} />
            </Form.Item>
          </Col>
          <Col span={24}>
            <div className={styles.buttonContainer}>
              <Button
                loading={uploading}
                block={screens.md ? false : true}
                type={"primary"}
                htmlType={"submit"}
              >
                {t("normal.update")}
              </Button>
            </div>
          </Col>
        </Row>
      </Form>
    </Card>
  );
};

export default ChangePassword;
